import React from "react"

import FormControl from "~components/shared/todo-lib-react-components/form-control"
import { TEST_IDS } from "~config/test-ids"
import Input from "~components/shared/todo-lib-react-components/input"

export interface Props {
    readonly label?: string
    readonly value: string
    readonly placeholder?: string
    readonly type?: string
    readonly onChange: (value: string) => void
    readonly isRequired?: boolean
    readonly noBottomMargin?: boolean
    readonly testId?: string
}

export default function TextInput({
    label,
    value,
    placeholder,
    type,
    onChange,
    isRequired,
    noBottomMargin,
    testId,
}: Props) {
    return (
        <FormControl label={label} noBottomMargin={noBottomMargin}>
            <Input
                testId={testId ?? TEST_IDS.TEXT_INPUT}
                placeholder={placeholder}
                value={value}
                type={type}
                onChange={(newValue) => onChange(newValue)}
                isRequired={isRequired}
            />
        </FormControl>
    )
}
